<template>
	<v-card flat outlined>
		<v-card-text>
			<v-row class="d-flex justify-center">
				<v-card-title class="pa-2 pb-0">{{ $t('titles.weeklySchedule') }}</v-card-title>
			</v-row>
			<v-row class="d-flex justify-space-between ml-4 mr-4">
				<v-col cols="12" class="pb-0">
					<Dropdown
						v-model="appointmentLocationId"
						:ajax="true"
						:data="'appointment-locations'"
						:label="'* ' + $t('fields.classroomShip')"
					></Dropdown>
				</v-col>
			</v-row>
			<v-row v-if="appointmentLocationId !== null">
				<v-col cols="12" class="pa-2">
					<WeeklyCalendar :appointmentLocationId="appointmentLocationId"></WeeklyCalendar
				></v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
import Dropdown from '../../trinkets/Dropdown';
import WeeklyCalendar from './WeeklyCalendar';

export default {
	name: 'WeeklySchedule',
	components: {
		Dropdown,
		WeeklyCalendar,
	},
	props: {},
	watch: {
		appointmentLocationId() {
			this.getWeeklyEvents();
		},
	},
	data() {
		return {
			appointmentLocationId: null,
		};
	},
	methods: {
		getWeeklyEvents() {},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}

		this.$myStore.commit('setBreadcrumbs', [
			{ text: this.$t('modules.weeklySchedule'), href: '/#/weekly-schedule', disabled: true },
		]);
	},
};
</script>

<style scoped></style>
